/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-07-21 17:16:22
 * @FilePath: \monitor\src\api\index.js
 * @Description:
 */
import Vue from "vue";
import VueResource from "vue-resource";
import * as config from "./config";
import Tools from "../libs/tools";
import { Modal } from "view-design";
import router from "@/router";
import { clear } from "@/libs/util";
import i18n from "@/main.js";

Vue.use(VueResource);
Vue.http.options.root = config.API_ROOT + "/api/v1";
Vue.http.options.emulateJSON = config.emulateJSON;
Vue.http.options.timeout = 600000;
function mergeJson(jsonbject1, jsonbject2) {
  var resultJsonObject = {};
  for (var attr in jsonbject1) {
    resultJsonObject[attr] = jsonbject1[attr];
  }
  for (var attr in jsonbject2) {
    resultJsonObject[attr] = jsonbject2[attr];
  }
  return resultJsonObject;
}

// HTTP相关
Vue.http.interceptors.push(function(request, next) {
  let loginInfo = Tools.methods.StorageGet("loginInfo");
  // 这里对请求体进行处理
  request.headers = request.headers || {};
  if (loginInfo) {
    request.headers.set("authtoken", loginInfo.token);
    request.headers.set("record", loginInfo.userId);
    // request.headers.set("Access-Control-Allow-Origin", "*");
    // request.headers.set("Access-Control-Allow-Headers", "Content-Type");
  } else {
    console.log("%%%%%%%%% NO loginInfo %%%%%%%%");
  }
  next(response => {
    //在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
    if (response.status != 200) {
      if (response.status == 401) {
        Modal.error({
          title: i18n.t("User.Login.tips"),
          content: i18n.t("User.Login.sessionLost"),
          onOk: () => {
            router.push({
              path: "/login"
              // query: {
              //   redirect: router.currentRoute.fullPath
              // }
            });
            clear();
          }
        });
      } else {
        Modal.error({
          title: i18n.t("User.Login.tips"),
          content: i18n.t("User.Login.connectionFailed"),
          onOk: () => {
            console.log(response.status);
            if (response.status != 404 && response.status != 0) {
              window.location.reload();
            }
          }
        });
      }
    }
  });
});

export const getTriggerEventData = function(fileName, sensorId) {
  try {
    const triggerEventDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getTriggerEventData"
    );
    return triggerEventDataResource.query({
      fileName: fileName,
      sensorId: sensorId
    });
  } catch (error) {
    console.log("getTriggerEventData API return ERROR:" + error);
  }
};
export const getTriggerEventDataAcc = function(fileName, sensorId) {
  try {
    const triggerEventDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getTriggerEventDataAcc"
    );
    return triggerEventDataResource.query({
      fileName: fileName,
      sensorId: sensorId
    });
  } catch (error) {
    console.log("getTriggerEventDataAcc API return ERROR:" + error);
  }
};

// B2优化: getTreeData 防抖去重
// 同一 projectId+adminTag+userId 在短时间内多次调用时，合并为一次请求，所有调用方共享同一个Promise
const _treeDataPending = {}; // 缓存进行中的请求

export const getTreeData = function(projectId, adminTag, userId) {
  // 生成请求唯一key
  const requestKey = projectId + '_' + adminTag + '_' + userId;

  // 如果已有相同请求正在进行，直接返回该Promise（去重）
  if (_treeDataPending[requestKey]) {
    return _treeDataPending[requestKey];
  }

  try {
    const treeDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getTreeData"
    );
    const promise = treeDataResource.query({
      projectId: projectId,
      adminTag: adminTag,
      userId: userId
    });

    // 缓存Promise，标记请求进行中
    _treeDataPending[requestKey] = promise;

    // 请求完成后清除缓存（无论成功或失败）
    const clearPending = () => { delete _treeDataPending[requestKey]; };
    promise.then(clearPending, clearPending);

    return promise;
  } catch (error) {
    console.log("getTreeData API return ERROR:" + error);
    delete _treeDataPending[requestKey];
    return Promise.reject(error);
  }
};

export const getCheckedSensorData = function(param) {
  try {
    const checkedSensorDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getCheckedSensorData"
    );
    return checkedSensorDataResource.query(param);
  } catch (error) {
    console.log("getCheckedSensorData API return ERROR:" + error);
  }
};

export const getCheckedSensorVMData = function(param) {
  try {
    const checkedSensorDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getCheckedSensorVMData"
    );
    return checkedSensorDataResource.query(param);
  } catch (error) {
    console.log("getCheckedSensorData API return ERROR:" + error);
  }
};
export const getCheckedSensorACData = function(param) {
  try {
    const checkedSensorDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getCheckedSensorACData"
    );
    return checkedSensorDataResource.query(param);
  } catch (error) {
    console.log("getCheckedSensorACData API return ERROR:" + error);
  }
};
export const getCheckedSensorVMDataDIN = function(param) {
  try {
    const checkedSensorDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getCheckedSensorVMDataDIN"
    );
    return checkedSensorDataResource.query(param);
  } catch (error) {
    console.log("getCheckedSensorVMDataDIN API return ERROR:" + error);
  }
};
export const getCheckedSensorPrismData = function(param) {
  try {
    const checkedSensorDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getCheckedSensorPrismData"
    );
    return checkedSensorDataResource.query(param);
  } catch (error) {
    console.log("getCheckedSensorData API return ERROR:" + error);
  }
};
export const getLastData = function(param) {
  try {
    const lastDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getLastData"
    );
    return lastDataResource.save(param);
  } catch (error) {
    console.log("getLastPrismData API return ERROR:" + error);
  }
};

export const getTotalLastData = function(param) {
  try {
    const totalLastDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getTotalLastData"
    );
    return totalLastDataResource.query(param);
  } catch (error) {
    console.log("getLastPrismData API return ERROR:" + error);
  }
};

export const getLastPrismData = function(param) {
  try {
    const lastPrismDataResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getLastPrismData"
    );
    return lastPrismDataResource.query(param);
  } catch (error) {
    console.log("getLastPrismData API return ERROR:" + error);
  }
};
// const res = await this.$myRequest({
//   url: '/api/v1/getSummary',
//   data: param,
//   record:this.userId,
// })
export const getSummary = function(param) {
  const getSummary = Vue.resource("getSummary");
  return getSummary.save(param);
};
// export const getSummary = function(param) {
//   try {
//     const summaryResource = Vue.resource(
//       config.API_ROOT + "/api/v1" + "/getSummary"
//     );
//     return summaryResource.query(param);
//   } catch (error) {
//     console.log("getLastPrismData API return ERROR:" + error);
//   }
// };

export const downLoadReport = function(param) {
  try {
    const downLoadReportResource = Vue.resource(
      config.API_ROOT + "/api/v1" + "/downloadReport"
    );
    return downLoadReportResource.query(param);
  } catch (error) {
    console.log("getLastPrismData API return ERROR:" + error);
  }
};

export const getMessage = function(param) {
  try {
    const messageResource = Vue.resource(
      config.API_ROOT + "/api/v1/getMessage"
    );
    return messageResource.query(param);
  } catch (error) {
    console.log("getMessage API return ERROR:" + error);
  }
};

/*********************************登录 相关 api *************************************************/
/**
 * 登录
 * @param data
 * @returns {*|{method}}
 */
export const loginIn = function(data) {
  try {
    const LoginResource = Vue.resource(config.API_ROOT + "/login");
    return LoginResource.save(data);
  } catch (error) {
    console.log(error);
  }
};

export const register = function(data) {
  try {
    const registerResource = Vue.resource(config.API_ROOT + "/register");
    return registerResource.save(data);
  } catch (error) {
    console.log(error);
  }
};

export const forgetpwd = function(data) {
  try {
    const forgetpwdResource = Vue.resource(config.API_ROOT + "/forgetpwd");
    return forgetpwdResource.save(data);
  } catch (error) {
    console.log(error);
  }
};

export const getcode = function(username) {
  try {
    const getcodeResource = Vue.resource(config.API_ROOT + "/getcode");
    return getcodeResource.query(username);
  } catch (error) {
    console.log(error);
  }
};

export const saveUserInfo = function(userInfo) {
  try {
    const saveUserInfoResource = Vue.resource(
      config.API_ROOT + "/saveUserinfo"
    );
    return saveUserInfoResource.save(userInfo);
  } catch (error) {
    console.log(error);
  }
};

//查询项目下的所有传感器
export const getUserInfosResource = function(params) {
  const getUserInfos = Vue.resource("getUserinfos");
  var json = JSON.stringify(params);
  return getUserInfos.query({ json: json });
};

//查询
export const getColumnsResource = function(tablename) {
  const getColumns = Vue.resource("getColumns{/tablename}");
  return getColumns.query({ tablename: tablename });
};

//pdf文件导出
export const saveDataToPdfResource = function(base64data) {
  const saveDataToPdf = Vue.resource("saveDataToPdf");
  return saveDataToPdf.save({ base64data: base64data });
};

//查询
export const getUserProjectResource = function(userId) {
  const getUserProject = Vue.resource("getUserProject{/userId}");
  return getUserProject.query({ userId: userId });
};

//保存用户项目权限接口
export const saveUserProjectResource = function(keys, userId, manageUser) {
  const saveUserProject = Vue.resource("saveUserProjects");
  return saveUserProject.save({
    keys: keys,
    userId: userId,
    manageUser: manageUser
  });
};

//查询
export const saveUserStatusResource = function(userId, status) {
  const saveUserStatus = Vue.resource("updateUserStatus{/userId}/{status}");
  return saveUserStatus.query({ userId: userId, status: status });
};

export const deleteUserInfo = function(userInfo) {
  try {
    const saveUserInfoResource = Vue.resource(
      config.API_ROOT + "/deleteUserinfo"
    );
    return saveUserInfoResource.delete(userInfo);
  } catch (error) {
    console.log(error);
  }
};

//addUserinfo
export const addUserinfo = function(userInfo) {
  try {
    const saveUserInfoResource = Vue.resource(config.API_ROOT + "/addUserinfo");
    return saveUserInfoResource.save(userInfo);
  } catch (error) {
    console.log(error);
  }
};

//获取用户的已配置的区域和未配置的区域接口
export const getUsersZoneResource = function(params) {
  const getUserZones = Vue.resource("getUserZones");
  return getUserZones.query(params);
};
//保存用户区域权限接口
export const saveUsersZonesResource = function(params) {
  const saveZoneUsers = Vue.resource("saveUserZones");
  return saveZoneUsers.save(params);
};
/*********************************采集器传感器 相关api *************************************************/
//根据项目编码获取项目下的采集器
export const getDataloggerInfoResource = function(id, type) {
  if (type === "1") {
    const getDataloggerInfo = Vue.resource(
      "getDataloggerInfoByLoggerId{/dataLoggerId}"
    );
    return getDataloggerInfo.query({ dataLoggerId: id });
  } else {
    const getDataloggerInfo = Vue.resource(
      "getDataloggerInfoByPrjId{/projectId}"
    );
    return getDataloggerInfo.query({ projectId: id });
  }
};
//根据采集器编码获取项目下的采集器
export const getDataloggerInfoByLoggerId = function(dataLoggerId) {
  const getDataloggerInfo = Vue.resource(
    "getDataloggerInfoByLoggerId{/dataLoggerId}"
  );
  return getDataloggerInfo.query({ dataLoggerId: dataLoggerId });
};
//根据传感器层级来获取传感器
export const getSensorInfoByCalculateLevel = function(params) {
  const getSensorInfo = Vue.resource("getSensorInfoByCalculateLevel");
  return getSensorInfo.save(params);
};
//根据采集器id来获取传感器的最大通道和当前us或kn的序号
export const getSensorMaxChannelAndUSOrKNNumber = function(params) {
  const getSensorInfo = Vue.resource("getSensorMaxChannelAndUSOrKNNumber");
  return getSensorInfo.save(params);
};
//根据传感器初值
export const updateSensorInitReading = function(params) {
  const updateSensorInitReading = Vue.resource("updateSensorInitReading");
  return updateSensorInitReading.save(params);
};
//根据采表名来获取最后一条数据
export const getTableLastData = function(params) {
  const getTableLastData = Vue.resource("getTableLastData");
  return getTableLastData.save(params);
};

//根据采集器名称获取项目下的采集器
export const getDataloggerInfoByLoggerName = function(dataLoggerName) {
  const getDataloggerInfo = Vue.resource(
    "getDataloggerInfoByLoggerName{/dataLoggerName}"
  );
  return getDataloggerInfo.query({ dataLoggerName: dataLoggerName });
};

//根据项目编码获取项目下的采集器
export const getDataloggerInfoByPrjId = function(projectId) {
  const getDataloggerInfo = Vue.resource(
    "getDataloggerInfoByPrjId{/projectId}"
  );
  return getDataloggerInfo.query({ projectId: projectId });
};

//获取首页地图展示的图标的采集器信息
export const getMapShowDataloggerApi = function(params) {
  const getMapShowDatalogger = Vue.resource("getMapShowDatalogger");
  return getMapShowDatalogger.query(params);
};

//获取采集器所有类型接口
export const getDataloggerModelList = function() {
  const getDataloggerInfo = Vue.resource("getDataloggerModelList");
  return getDataloggerInfo.query();
};
//根据采集器model获取采集器周期列表数据
export const getDataloggerIntervalByModel = function(dataloggerModel) {
  const getDataloggerInfo = Vue.resource(
    "getDataloggerIntervalByModel{/dataloggerModel}"
  );
  return getDataloggerInfo.query({ dataloggerModel });
};

//查询采集器分页数据
export const getDataloggerPageResource = function(params) {
  const getDataloggerInfo = Vue.resource("getDataloggerPage");
  var json = JSON.stringify(params);
  return getDataloggerInfo.query({ json: json });
};
//查询传感器分页数据
export const getSensorPageResource = function(params) {
  const getSensorList = Vue.resource("getSensorPage");
  var json = JSON.stringify(params);
  return getSensorList.query({ json: json });
};

//保存采集器信息
export const saveDataloggerResource = function(dataloggerInfo) {
  const saveDatalogger = Vue.resource("saveDataloggerInfo");
  return saveDatalogger.save(dataloggerInfo);
};
//更新采集器信息
export const updateDataloggerResource = function(dataloggerInfo) {
  const updateDatalogger = Vue.resource("updateDataloggerInfo");
  return updateDatalogger.save(dataloggerInfo);
};

//删除项目信息
export const delDataloggerResource = function(dataloggerId) {
  const delDatalogger = Vue.resource("delDataloggerInfo{/dataloggerId}");
  return delDatalogger.delete({ dataloggerId: dataloggerId });
};
//
export const getDataloggertabResource = function(dataloggerId) {
  const getDataloggertab = Vue.resource("getDataloggertabById{/dataloggerId}");
  return getDataloggertab.query({ dataloggerId: dataloggerId });
};

export const getDataloggertabBylevelResource = function(dataloggerId, level) {
  const getDataloggertabBylevel = Vue.resource(
    "getDataloggertabByIdAndLevel{/dataloggerId}/{level}"
  );
  return getDataloggertabBylevel.query({
    dataloggerId: dataloggerId,
    level: level
  });
};

//根据时间点查询传感器的数据
export const getSensorDataByLastTime = function(params) {
  try {
    const getSensorDataByLastTimeList = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getSensorDataByLastTime"
    );
    return getSensorDataByLastTimeList.query(params);
  } catch (error) {
    console.log("getSensorDataByLastTime API return ERROR:" + error);
  }
};
//根据时间范围查询传感器的数据
export const getAvgSensorDataByTime = function(params) {
  try {
    const getAvgSensorDataByTimeList = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getAvgSensorDataByTime"
    );
    return getAvgSensorDataByTimeList.query(params);
  } catch (error) {
    console.log("getAvgSensorDataByTime API return ERROR:" + error);
  }
};
//根据项目id查询统计信息
export const getStatistic = function(params) {
  try {
    const getStatisticList = Vue.resource(
      config.API_ROOT + "/api/v1" + "/getStatistic"
    );
    return getStatisticList.query(params);
  } catch (error) {
    console.log("getStatistic API return ERROR:" + error);
  }
};
/*********************************区域，区域类型查询相关api *************************************************/
//通过projectId查询区域数据
export const getZoneInfoByProjectIdResource = function(projectId) {
  const getZoneInfoByProjectId = Vue.resource(
    "getZoneInfoByProjectId{/projectId}"
  );
  return getZoneInfoByProjectId.query({ projectId });
};
//通过zoneId查询区域类别数据
export const getZoneCategoryInfoByZoneIdResource = function(zoneId) {
  const getZoneCategoryInfoByZoneId = Vue.resource(
    "getZoneCategoryInfoByZoneId{/zoneId}"
  );
  return getZoneCategoryInfoByZoneId.query({ zoneId });
};
//查询区域分页数据
export const getZoneListResource = function(params) {
  const getZoneList = Vue.resource("getZoneList");
  var json = JSON.stringify(params);
  return getZoneList.query({ json: json });
};
//添加区域信息
export const addZoneInfoResource = function(zoneInfo) {
  const addZoneInfo = Vue.resource("addZoneInfo");
  return addZoneInfo.save(zoneInfo);
};
//修改区域信息
export const updateZoneInfoResource = function(zoneInfo) {
  const updateZoneInfo = Vue.resource("updateZoneInfo");
  return updateZoneInfo.save(zoneInfo);
};
//删除区域信息
export const delZoneInfoResource = function(projectId, zoneId) {
  const delZoneInfo = Vue.resource("delZoneInfo/{projectId}/{zoneId}");
  return delZoneInfo.delete({ projectId, zoneId });
};
//查询区域类别（采集器类别）分页数据
export const getZoneCategoryListResource = function(params) {
  const getZoneCategoryList = Vue.resource("getZoneCategoryList");
  var json = JSON.stringify(params);
  return getZoneCategoryList.query({ json });
};
//添加区域类别（采集器类别）信息
export const addZoneCategoryInfo = function(zoneCategoryInfo) {
  const addZoneCategoryInfo = Vue.resource("addZoneCategoryInfo");
  return addZoneCategoryInfo.save(zoneCategoryInfo);
};
//修改区域类别（采集器类别）信息
export const updateZoneCategoryInfo = function(zoneCategoryInfo) {
  const updateZoneCategoryInfo = Vue.resource("updateZoneCategoryInfo");
  return updateZoneCategoryInfo.save(zoneCategoryInfo);
};
//删除区域信息
export const delZoneCategoryInfo = function(projectId, zoneId, categoryId) {
  const delZoneCategoryInfo = Vue.resource(
    "delZoneCategoryInfo/{projectId}/{zoneId}/{categoryId}"
  );
  return delZoneCategoryInfo.delete({ projectId, zoneId, categoryId });
};
//获取区域的已配置的用户和未配置的用户接口
export const getZoneUsersResource = function(params) {
  const getZoneUsers = Vue.resource("getZoneUsers");
  return getZoneUsers.query(params);
};
//保存区域用户权限接口
export const saveZoneUsersResource = function(params) {
  const saveZoneUsers = Vue.resource("saveZoneUsers");
  return saveZoneUsers.save(params);
};

/*********************************传感器 相关api *************************************************/
//查询项目下的所有传感器
export const getAllSensorinfoResource = function(id, type) {
  //按项目ID查询
  if (type === "1") {
    const getAllSensorinfo = Vue.resource("getAllSensorinfo{/projectId}");
    return getAllSensorinfo.query({ projectId: id });
  }
  //按传感器查询
  if (type === "2") {
    const getAllSensorinfo = Vue.resource("getSensorinfoById{/sensorId}");
    return getAllSensorinfo.query({ sensorId: id });
  }
  //按采集器查
  if (type === "3") {
    const getAllSensorinfo = Vue.resource(
      "getSensorinfoBydataloggerId{/dataloggerId}"
    );
    // return getAllSensorinfo.query({ dataloggerId: id ,record:Tools.methods.StorageGet("loginInfo").token});
    return getAllSensorinfo.query({ dataloggerId: id });
  }
};

//根据项目编号查询项目下的所有传感器
export const getSensorByProjectIdAndUserId = function(param) {
  const getSensorByProjectIdAndUserId = Vue.resource(
    "getSensorByProjectIdAndUserId"
  );
  return getSensorByProjectIdAndUserId.query(param);
};

//根据项目编号查询项目下的所有传感器
export const getSensorinfoByPrjId = function(projectId) {
  const getAllSensorinfo = Vue.resource("getAllSensorinfo{/projectId}");
  return getAllSensorinfo.query({ projectId: projectId });
};

//根据传感器编号查询项目下的所有传感器
export const getSensorinfoBySensorId = function(sensorId) {
  const getAllSensorinfo = Vue.resource("getSensorinfoBySensorId{/sensorId}");
  return getAllSensorinfo.query({ sensorId: sensorId });
};

//查询项目下的所有传感器
export const getSensorinfoByLoggerId = function(dataloggerId) {
  const getAllSensorinfo = Vue.resource(
    "getSensorinfoBydataloggerId{/dataloggerId}"
  );
  return getAllSensorinfo.query({ dataloggerId: dataloggerId });
};

//查询采集器下传感器的采集数据20条
export const getSensordataResource = function(
  id,
  type,
  level,
  startTime,
  endTime
) {
  if (type === "1") {
    const getSensordata = Vue.resource("getSensordataBydataloggerId");
    if (startTime && endTime) {
      return getSensordata.query({
        dataloggerId: id,
        startTime: startTime,
        endTime: endTime,
        calculateLevel: level
      });
    } else {
      return getSensordata.query({ dataloggerId: id, calculateLevel: level });
    }
  }
  if (type === "2") {
    const getSensordata = Vue.resource(
      "getSensordataBysensorId{/sensorId}/{startTime}/{endTime}"
    );
    return getSensordata.query({
      sensorId: id,
      startTime: startTime,
      endTime: endTime
    });
  }
};

//根据时间端查询采集器下传感器的采集数据，根据顶级传感器获取所有下级传感器的数据
export const getSensordataByIdLevelResource = function(
  id,
  level,
  startTime,
  endTime
) {
  const getSensordata = Vue.resource(
    "getSensordataByTopsensorIdLevel{/sensorId}/{level}/{startTime}/{endTime}"
  );
  return getSensordata.query({
    sensorId: id,
    level: level,
    startTime: startTime,
    endTime: endTime
  });
};

//根据采集器获取该采集器下最顶级的传感器
export const getTopSensorInfoByloggerIdResource = function(dataloggerId) {
  const getTopSensorInfoByloggerId = Vue.resource(
    "getTopSensorInfoByDataloggerId{/dataloggerId}"
  );
  return getTopSensorInfoByloggerId.query({ dataloggerId: dataloggerId });
};

//添加传感器数据
export const addSensorResource = function(sensorInfo) {
  const addSensor = Vue.resource("addSensorInfo");
  return addSensor.save(sensorInfo);
};
//更新传感器信息
export const updateSensorResource = function(sensorInfo) {
  const updateSensor = Vue.resource("updateSensorInfo");
  return updateSensor.save(sensorInfo);
};
//删除传感器信息
export const delSensorInfoResource = function(sensorInfo) {
  const delSensorInfo = Vue.resource("delSensorInfo");
  return delSensorInfo.delete(sensorInfo);
};
// export const delSensorInfoResource = function(sensorId) {
//   const delSensorInfo = Vue.resource("delSensorInfo{/sensorId}");
//   return delSensorInfo.delete({ sensorId });
// };
/*********************************项目管理 相关api *************************************************/
//添加项目信息
export const addProjectResource = function(projectInfo) {
  const addProject = Vue.resource("addProjectInfo");
  return addProject.save(projectInfo);
};
//添加项目图片
export const imageUploadResource = function(imageInfo) {
  const imageUpload = Vue.resource("imageUpload");
  return imageUpload.save(imageInfo);
};
//查询项目图片列表
export const getProjectImageResource = function(params) {
  const getProjectImage = Vue.resource("getProjectImage");
  var json = JSON.stringify(params);
  return getProjectImage.query({ json: json });
};

//删除项目图片
export const delProjectImageResource = function(id) {
  const delProjectImage = Vue.resource("delProjectImage{/id}");
  return delProjectImage.delete({ id: id });
};

//保存项目信息
export const saveProjectResource = function(projectInfo) {
  const saveProject = Vue.resource("saveProjectInfo");
  return saveProject.save(projectInfo);
};

//删除项目信息
export const delProjectResource = function(projectId) {
  const delProject = Vue.resource("delProjectInfo{/projectId}");
  return delProject.delete({ projectId: projectId });
};

//查询项目列表
export const getAllProjectInfoResource = function(params) {
  const getAllProjectInfo = Vue.resource("getAllProjectInfo");
  var json = JSON.stringify(params);
  return getAllProjectInfo.query({ json: json });
};
//查询所有项目列表
export const getAllProjectResource = function() {
  const getAllProject = Vue.resource("getAllProject");
  return getAllProject.query();
};
//查询项目下的所有传感器
export const getRootTreeNodeResource = function(projectId) {
  const getRootTreeNode = Vue.resource("getRootTreeNode{/projectId}");
  return getRootTreeNode.query({ projectId: projectId });
};

/*********************************pointEx 相关api *************************************************/
//查询项目下的所有截面点
export const getPointsExInfosResource = function(projectId) {
  const getPointsExInfos = Vue.resource("getPointsExInfos{/projectId}");
  return getPointsExInfos.query({ projectId: projectId });
};

export const getPointExDataInfosResource = function(
  projectId,
  index,
  date,
  num
) {
  const getPointExDataInfos = Vue.resource(
    "getPointExDataInfos{/projectId}/{index}/{date}/{num}"
  );
  return getPointExDataInfos.query(
    { projectId: projectId, index: index, date: date, num: num },
    { record: Tools.methods.StorageGet("loginInfo").userId }
  );
};

export const getAvgPointExDataInfosResource = function(projectId, index, date) {
  const getAvgPointExDataInfos = Vue.resource(
    "getAvgPointExDataInfos{/projectId}/{index}/{date}"
  );
  return getAvgPointExDataInfos.query({
    projectId: projectId,
    index: index,
    date: date
  });
};

export const getPointExDataHisInfosResource = function(
  projectId,
  positionId,
  index,
  epoch
) {
  const getPointExDataHisInfos = Vue.resource(
    "getPointExDataHisInfos{/projectId}/{positionId}/{index}/{epoch}"
  );
  return getPointExDataHisInfos.query({
    projectId: projectId,
    positionId: positionId,
    index: index,
    epoch: epoch
  });
};

export const getPointExDataHisInfos4PointResource = function(
  projectId,
  pointId,
  index
) {
  const getPointExDataHisInfos = Vue.resource(
    "getPointExDataHisInfos{/projectId}/{pointId}/{index}"
  );
  return getPointExDataHisInfos.query({
    projectId: projectId,
    pointId: pointId,
    index: index
  });
};

export const getPointExDataHisInfosByDateResource = function(
  pointId,
  startDate,
  endDate
) {
  const getPointExDataHisInfosByDate = Vue.resource(
    "getPointExDataHisInfosByDate{/pointId}/{startDate}/{endDate}"
  );
  return getPointExDataHisInfosByDate.query({
    pointId: pointId,
    startDate: startDate,
    endDate: endDate
  });
};

export const getLastestEpochResource = function(projectId) {
  const getLastestEpoch = Vue.resource("getLastestEpoch{/projectId}");
  return getLastestEpoch.query({ projectId: projectId });
};

/*********************************section 相关api *************************************************/
export const getSectionDataInfosResource = function(projectId, epoch, num) {
  const getSectionDataInfos = Vue.resource(
    "getSectionDataInfos{/projectId}/{epoch}/{num}"
  );
  return getSectionDataInfos.query({
    projectId: projectId,
    epoch: epoch,
    num: num
  });
};

export const getSectionDataHisInfosResource = function(projectId, epoch) {
  const getSectionDataInfos = Vue.resource(
    "getSectionDataHisInfos{/projectId}/{epoch}"
  );
  return getSectionDataInfos.query({ projectId: projectId, epoch: epoch });
};

export const getSectionColumnsByDirtIdResource = function(projectId, epoch) {
  const getSectionColumnsByDirtId = Vue.resource(
    "getSectionColumnsByDirtId{/projectId}/{directionId}"
  );
  return getSectionColumnsByDirtId.query({
    projectId: projectId,
    directionId: epoch
  });
};

export const getSectionPointsByPrjResource = function(projectId) {
  const getSectionPointsByPrj = Vue.resource(
    "getSectionPointsByPrj{/projectId}"
  );
  return getSectionPointsByPrj.query({ projectId: projectId });
};

/*********************************report 相关api *************************************************/
export const getDailyReportLogByIdResource = function(params) {
  // const getDailyReportLogInfo = Vue.resource('getDailyReportLogById{/projectId}/{datetime}');
  // return getDailyReportLogById.query({ projectId: projectId, datetime: datetime });

  const getDailyReportLogInfo = Vue.resource("getDailyReportLogList");
  var json = JSON.stringify(params);
  return getDailyReportLogInfo.query({ json: json });
};

/********************************* 报表生成的相应数据接口 *************************************************/
//查询TN1086、AN1001类型传感器数据接口
export const getTN1086orAN1001SensorDataApi = function(params) {
  const getTN1086orAN1001SensorData = Vue.resource(
    "getTN1086orAN1001SensorData"
  );
  return getTN1086orAN1001SensorData.save(params);
};

//查询AC1003、VM2030类型传感器数据接口,查询intervaldata时tableName就传intervaldata的表名，查询triggerdata时tableName就传triggerdata的表名，
export const getAC1003orVM2030SensorDataApi = function(params) {
  const getAC1003orVM2030SensorData = Vue.resource(
    "getAC1003orVM2030SensorData"
  );
  return getAC1003orVM2030SensorData.save(params);
};

// 实时图表页面查询TN1086、AN1001类型传感器数据接口
export const getOrdinarySensorDataApi = function(params) {
  const getOrdinarySensorData = Vue.resource("getOrdinarySensorData");
  return getOrdinarySensorData.save(params);
};
// 实时图表页面查询 TotalStation 类型传感器数据接口
export const getTotalStationSensorDataApi = function(params) {
  const getTotalStationSensorData = Vue.resource("getTotalStationSensorData");
  return getTotalStationSensorData.save(params);
};

// 获取验证码
export const getCaptchaApi = function(params) {
  const getCaptcha = Vue.resource(config.API_ROOT + "/getCaptcha");
  return getCaptcha.query(params);
};
// 修改密码
export const changePasswordApi = function(params) {
  const changePassword = Vue.resource(config.API_ROOT + "/changePassword");
  return changePassword.query(params);
};
//查询分组分页数据
export const getSensorGroupPage = function(params) {
  const getSensorGroupList = Vue.resource("getSensorGroupPage");
  var json = JSON.stringify(params);
  return getSensorGroupList.query({ json: json });
};
//添加分组数据
export const addSensorGroupInfo = function(sensorGroupInfo) {
  const addSensor = Vue.resource("addSensorGroupInfo");
  return addSensor.save(sensorGroupInfo);
};
//更新分组信息
export const updateSensorGroupInfo = function(sensorGroupInfo) {
  const updateSensorGroup = Vue.resource("updateSensorGroupInfo");
  return updateSensorGroup.save(sensorGroupInfo);
};
//删除分组信息
export const delSensorGroupInfo = function(sensorGroupInfo) {
  const delSensorGroup = Vue.resource("delSensorGroupInfo");
  return delSensorGroup.delete(sensorGroupInfo);
};

//更新ac采集器的文件状体filestatus
export const updateACFileStatus = function(params) {
  const getSensorInfo = Vue.resource("updateACFileStatus");
  return getSensorInfo.save(params);
};

// 实时图表页面查询 TotalStation 类型传感器数据接口2
export const getTSSensorDataGroupAndTimeApi = function(params) {
  const getTSSensorDataGroupAndTime = Vue.resource(
    "getTSSensorDataGroupAndTime"
  );
  return getTSSensorDataGroupAndTime.query(params);
};
// 实时图表页面查询 IPI001 类型传感器数据接口2
export const getIPI001SensorDataApi = function(params) {
  const getIPI001SensorDataApi = Vue.resource("getIPI001SensorData");
  return getIPI001SensorDataApi.query(params);
};

//查询报警记录分页数据
export const getAlarmRecordPage = function(params) {
  const getAlarmRecordList = Vue.resource("getAlarmRecordPage");
  var json = JSON.stringify(params);
  return getAlarmRecordList.query({ json: json });
};
//查询项目全况报表数据-mysql存储过程
export const getProjectOverViewData = function(params) {
  const getProjectOverViewData = Vue.resource("getProjectOverViewData");
  var json = JSON.stringify(params);
  return getProjectOverViewData.query({ json: json });
};
//查询项目全况报表数据-java
export const getProjectOverViewReportData = function(params) {
  const getProjectOverViewData = Vue.resource("getProjectOverViewReportData");
  var json = JSON.stringify(params);
  return getProjectOverViewData.query({ json: json });
};

//查询项目分区分页数据
export const getPartitionPage = function(params) {
  const getPartitionPageList = Vue.resource("getPartitionPage");
  var json = JSON.stringify(params);
  return getPartitionPageList.query({ json: json });
};
// 获取最新的vn数据，用户测试界面
export const getVNLatestData = function(dataloggerName, dataloggerType) {
  const getSectionDataInfos = Vue.resource("getVNLatestData");
  return getSectionDataInfos.query({ dataloggerName, dataloggerType });
};
// 根据sectionId获取传感器最新数据
export const getSensorDataBySectionId = function(sectionId) {
  const getSensorDataBySectionIdInfos = Vue.resource(
    "getSensorDataBySectionId"
  );
  return getSensorDataBySectionIdInfos.query({ sectionId });
};
// 批量添加传感器
export const batchAddSensor = function(sensorJson) {
  const batchAddSensor = Vue.resource("batchAddSensor");
  return batchAddSensor.save(sensorJson);
};
// 修改告警参数
export const updateAlarmParameters = function(alarmParameters) {
  const updateAlarmParameters = Vue.resource("updateAlarmParameters");
  return updateAlarmParameters.save(alarmParameters);
};
//更新告警配置信息
export const alarmConfigurationApi = function(zoneInfo) {
  const alarmConfiguration = Vue.resource("alarmConfigurationApi");
  return alarmConfiguration.save(zoneInfo);
};

// 获取ipi001下需要设定初值的传感器
export const getIPI001SensorList = function(dataloggerId) {
  const getIPI001SensorListInfos = Vue.resource("getIPI001SensorList");
  return getIPI001SensorListInfos.query({ dataloggerId });
};

// 获取采集器下需要设定初值的传感器
export const getInitializeSensorList = function(dataloggerId, initReadingFlag) {
  const getInitializeSensorList = Vue.resource("getInitializeSensorList");
  return getInitializeSensorList.query({ dataloggerId, initReadingFlag });
};

// 批量更新ipi001初值数据
export const updateIPI001InitReading = function(params) {
  const updateIPI001InitReading = Vue.resource("updateIPI001InitReading");
  return updateIPI001InitReading.save(params);
};

// 批量更新vn,tn初值数据
export const updateInitReading = function(params) {
  const updateInitReading = Vue.resource("updateInitReading");
  return updateInitReading.save(params);
};

// 批量获取传感器某个时间段的平均数据
export const getBatchAvgSensorDataByTime = function(params) {
  const getBatchAvgSensorDataByTime = Vue.resource(
    "getBatchAvgSensorDataByTime"
  );
  return getBatchAvgSensorDataByTime.save(params);
};

// 获取vn下的传感器
export const getVNSensorList = function(params) {
  const getVNSensorListInfos = Vue.resource("getVNSensorList");
  var json = JSON.stringify(params);
  return getVNSensorListInfos.query({ json });
};

// 获取vn的传感器数据
export const getVNSensorData = function(params) {
  const getVNSensorData = Vue.resource("getVNSensorData");
  return getVNSensorData.save(params);
};

// 获取初值记录数据
export const getInitReadingRecordList = function(params) {
  const getInitReadingRecordListInfos = Vue.resource("getInitReadingRecordList");
  var json = JSON.stringify(params);
  return getInitReadingRecordListInfos.query({ json });
};

// 下载pdf
export const exportVNPdf = function(params, user) {
  const exportVNPdf = Vue.resource("exportVNPdf/" + user);
  return exportVNPdf.save(params);
};

//根据项目id获取ts的采集器和传感器
export const getTotalStationDataloggerAndSensor = function(params) {
  const getTotalStationDataloggerAndSensor = Vue.resource(
    "getTotalStationDataloggerAndSensor"
  );
  return getTotalStationDataloggerAndSensor.save(params);
};
//获取ts的两个日期的第一条数据
export const getTSSensorData = function(params) {
  const getTSSensorData = Vue.resource("getTSSensorData");
  return getTSSensorData.save(params);
};

export const getZoneCategoryNameList = function() {
  const getZoneCategoryNameList = Vue.resource("getZoneCategoryNameList");
  return getZoneCategoryNameList.query();
};

// 根据zoneId和dataTime获取VM的传感器数据
export const getVMSensorData = function(params) {
  const getVMSensorData = Vue.resource("getVMSensorData");
  return getVMSensorData.save(params);
};

// 根据zoneId和时间范围获取VM的传感器数据的统计条数
export const getVMSensorDataStatistics = function(params) {
  const getVMSensorDataStatistics = Vue.resource("getVMSensorDataStatistics");
  return getVMSensorDataStatistics.save(params);
};

// 保存VM的备注
export const saveVMRemarkData = function(params) {
  const saveVMRemarkData = Vue.resource("saveVMRemarkData");
  return saveVMRemarkData.save(params);
};

// 根据dataId和dataloggerId获取VM备注的图片数据
export const getVMRemarkImage = function(params) {
  const getVMRemarkImage = Vue.resource("getVMRemarkImage");
  return getVMRemarkImage.save(params);
};

//删除vm图片
export const delVMImageResource = function(id) {
  const delVMImage = Vue.resource("delVMImage{/id}");
  return delVMImage.delete({ id: id });
};

//添加VM图片
export const vmImageUploadResource = function(imageInfo) {
  const vmImageUpload = Vue.resource("vmImageUpload");
  return vmImageUpload.save(imageInfo);
};

// 根据zoneId,时间范围获取AN1001数据
export const getAN1001SensorData = function(params) {
  const getAN1001SensorData = Vue.resource("getAN1001SensorData");
  return getAN1001SensorData.save(params);
};

//查询gzm分页数据
export const getGzmInfoPage = function(params) {
  const getGzmInfoPage = Vue.resource("getGzmInfoPage");
  var json = JSON.stringify(params);
  return getGzmInfoPage.query({ json: json });
};
//添加gzm信息
export const addGzmInfoResource = function(gzmInfo) {
  const addGzmInfo = Vue.resource("addGzmInfo");
  return addGzmInfo.save(gzmInfo);
};
//修改gzm信息
export const updateGzmInfoResource = function(gzmInfo) {
  const updateGzmInfo = Vue.resource("updateGzmInfo");
  return updateGzmInfo.save(gzmInfo);
};
//删除gzm信息
export const delGzmInfoResource = function(params) {
  const delGzmInfo = Vue.resource("delGzmInfo");
  return delGzmInfo.delete(params);
};
// 获取gzm全部的数据，以sensorId返回
export const getGzmAllList = function(params) {
  const getGzmAllList = Vue.resource("getGzmAllList");
  return getGzmAllList.save(params);
};
// 更新datalogger的apiType和lastDataTime数据
export const updateDataloggerParameter = function(params) {
  const updateDataloggerParameter = Vue.resource("updateDataloggerParameter");
  return updateDataloggerParameter.save(params);
};

// 导出VM Excel接口
export const exportVMExcel = function(userId, queryJson, startTime, endTime) {
  const params = new URLSearchParams();
  params.append("userId", userId);
  params.append("queryJson", queryJson);
  params.append("startTime", startTime);
  params.append("endTime", endTime);

  return fetch(config.API_ROOT + "/api/v1/exportVMExcel", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: params
  });
};

// 导出VM PDF接口
export const exportVMPDF = function(userId, queryJson, startTime, endTime) {
  const params = new URLSearchParams();
  params.append("userId", userId);
  params.append("queryJson", queryJson);
  params.append("startTime", startTime);
  params.append("endTime", endTime);

  return fetch(config.API_ROOT + "/api/v1/exportVMPDF", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: params
  });
};


// WEBPACK FOOTER //
// ./src/api/index.js